import React from 'react';
import { FormNumber } from '@digital/ui';
import { Props } from '@digital/ui/lib/components/FormNumber';

const CurrencyInput = ({ ...props }: Props) => {

    const handleParser = (number: string) => {
        //let valor = number.replace(/[^0-9]/g, "");
        let valor = number.replace(/[^0-9-]/g, '').replace(/(?!^)-/g, '');
        let valorFloat = parseFloat(valor) / 100;
        if (isNaN(valorFloat)) return '0,00';
        return valorFloat.toFixed(2);
    };

    const thousandSeparator = (x) => {
        let values = x.split('.');
        let integers = values[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (values[1] == undefined) return integers + ',00';
        if (values[1].lenght === 1) return integers + (values[1] ? ',' + values[1] : '0');
        return integers + (values[1] ? ',' + values[1] : '');
    };

    return <FormNumber
        parser={handleParser}
        formatter={e => thousandSeparator(e)}
        {...props}
    />;
};

export default CurrencyInput;
